<script>
    import { onMount } from "svelte";

    import { user } from "../../stores";

    import {
        PageHead,
        PageLoading,
    } from "../../Components/Common/index.svelte";

    import { apiMethods } from "../../Services/index.svelte";

    import {
        goToDownloadPage,
        showError,
    } from "../../Utils/utilFunctions.svelte";

    import ViewInvoicesHeadDetails from "../Invoices/components/ViewInvoicesHeadDetails.svelte";
    import GroupDetails from "./components/GroupDetails.svelte";
    import ViewInvoicesInvoiceDetails from "../Invoices/components/ViewInvoicesInvoiceDetails.svelte";
    import GroupInvoiceItems from "./components/GroupInvoiceItems.svelte";

    export let params = {};

    let isLoading = false,
        isDownloadingPDF = false,
        invoiceDetails = {},
        groupDetails = {};

    $: isUserEnableSeeDoctorDetails = $user.role >= 20;

    onMount(() => {
        if (params.id) getInvoiceDetails(params.id);
    });

    const getInvoiceDetails = async (id) => {
        isLoading = true;

        await apiMethods.getMethod
            .getExternalGroupInvoiceById(id)
            .then(async (res) => {
                if (res.id) {
                    invoiceDetails = { ...res };

                    _updateBillingItemsData();

                    await loadGroupDetails();
                } else
                    showError(
                        "Unable to load this invoice, please refresh the page and try again and contact support if the issue persists.",
                        true,
                    );
            });

        isLoading = false;
    };

    const loadGroupDetails = async () => {
        await apiMethods.getMethod
            .getExternalGroupById(invoiceDetails.groupId)
            .then((res) => {
                if (!res || res.error)
                    showError(
                        res.error ??
                            "Failed to load external group details, please refresh the page and try again and contact support if the issue persists.",
                    );
                else groupDetails = { ...res };
            })
            .catch((err) => showError(err));
    };

    const getFile = () => {
        goToDownloadPage(14, invoiceDetails.id);
    };

    const _updateBillingItemsData = () => {
        if (invoiceDetails.billingItems.length) {
            const lastItem = {
                isLast: true,
                totalAmount: invoiceDetails.billingItems.reduce(
                    (sum, { totalAmount }) => sum + totalAmount,
                    0,
                ),
            };

            invoiceDetails.billingItems.push(lastItem);
        }
    };
</script>

{#if isLoading}
    <PageLoading />
{:else}
    <PageHead
        title="View invoice details"
        buttonText={isDownloadingPDF
            ? "Downloading PDF"
            : "Download invoice PDF"}
        buttonStyle={isDownloadingPDF ? "loading" : ""}
        buttonDisabled={isDownloadingPDF}
        buttonFunc={getFile}
        isRevertBtnOrder={true}
    />

    <div class="flex-1 relative mt-4">
        <div class="flex flex-col overflow-y-auto absolute inset-0 gap-4 px-2">
            <ViewInvoicesHeadDetails {invoiceDetails} />

            {#if isUserEnableSeeDoctorDetails}
                <GroupDetails {groupDetails} />
            {/if}

            <ViewInvoicesInvoiceDetails
                {invoiceDetails}
                downloadInvoiceType={14}
                isFromAccountPage
            />

            <GroupInvoiceItems billingItems={invoiceDetails.billingItems} />
        </div>
    </div>
{/if}
